export const createIframes = (locale: string) => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('src', `/assets/iframe/cookiebot-${locale}.html`);
  iframe.setAttribute('data-consent', 'marketing');
  iframe.setAttribute('data-locale', locale);
  return iframe;
};
